
import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../components/base/Button';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';

export default function ResultsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const plateNumber = searchParams.get('plate') || '';
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState<any>(null);

  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      // Mock result - sometimes found, sometimes not
      const hasResult = Math.random() > 0.3;
      
      if (hasResult) {
        setResult({
          plateNumber,
          ownerName: 'أحمد محمد',
          carModel: 'تويوتا كامري 2020',
          contactMethods: [
            { type: 'phone', value: '+966501234567', label: 'الهاتف' },
            { type: 'whatsapp', value: '+966501234567', label: 'واتساب' },
            { type: 'email', value: 'ahmed@example.com', label: 'البريد الإلكتروني' }
          ],
          carImage: 'https://public.readdy.ai/ai/img_res/39b96984f1f7c15047265900668b1bee.jpg'
        });
      } else {
        setResult(null);
      }
      setLoading(false);
    }, 2000);
  }, [plateNumber]);

  const handleContact = (method: any) => {
    if (method.type === 'phone') {
      window.location.href = `tel:${method.value}`;
    } else if (method.type === 'whatsapp') {
      window.open(`https://wa.me/${method.value.replace('+', '')}`, '_blank');
    } else if (method.type === 'email') {
      window.location.href = `mailto:${method.value}`;
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 pb-20">
        <TopNavigation title="نتائج البحث" showBack={true} />
        <div className="pt-16 px-6 py-8 flex flex-col items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4 mx-auto">
              <i className="ri-loader-4-line animate-spin text-2xl text-purple-600 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              جارٍ البحث عن صاحب السيارة...
            </h2>
            <p className="text-gray-600">
              رقم اللوحة: {plateNumber}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <TopNavigation title="نتائج البحث" showBack={true} />
      
      <div className="pt-16 px-6 py-8">
        {result ? (
          <div className="space-y-6">
            {/* Success Header */}
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-check-line text-2xl text-green-600 w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                تم العثور على صاحب السيارة!
              </h2>
              <p className="text-gray-600">
                رقم اللوحة: {result.plateNumber}
              </p>
            </div>

            {/* Car Info Card */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <img
                src={result.carImage}
                alt="Car"
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {result.carModel}
                </h3>
                <p className="text-gray-600 mb-4">
                  المالك: {result.ownerName}
                </p>
                
                {/* Contact Methods */}
                <div className="space-y-3">
                  <h4 className="font-medium text-gray-900">طرق التواصل:</h4>
                  {result.contactMethods.map((method: any, index: number) => (
                    <button
                      key={index}
                      onClick={() => handleContact(method)}
                      className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                      <div className="flex items-center space-x-3 rtl:space-x-reverse">
                        <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                          <i className={`${
                            method.type === 'phone' ? 'ri-phone-line' :
                            method.type === 'whatsapp' ? 'ri-whatsapp-line' :
                            'ri-mail-line'
                          } text-purple-600 w-5 h-5 flex items-center justify-center`}></i>
                        </div>
                        <div className="text-right">
                          <p className="font-medium text-gray-900">{method.label}</p>
                          <p className="text-sm text-gray-600">{method.value}</p>
                        </div>
                      </div>
                      <i className="ri-arrow-left-line text-gray-400 w-5 h-5 flex items-center justify-center"></i>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="space-y-3">
              <Button
                onClick={() => navigate('/search')}
                className="w-full"
                variant="outline"
              >
                بحث جديد
              </Button>
              <Button
                onClick={() => navigate('/home')}
                className="w-full"
              >
                العودة للرئيسية
              </Button>
            </div>
          </div>
        ) : (
          <div className="text-center">
            {/* No Results */}
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4 mx-auto">
              <i className="ri-close-line text-2xl text-red-600 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              لا توجد نتائج
            </h2>
            <p className="text-gray-600 mb-6">
              لم يتم العثور على معلومات لرقم اللوحة: {plateNumber}
            </p>
            
            <div className="bg-purple-50 rounded-xl p-6 mb-6">
              <h3 className="font-semibold text-purple-900 mb-2">اقتراحات:</h3>
              <ul className="text-purple-800 text-sm space-y-1 text-right">
                <li>• تأكد من صحة رقم اللوحة</li>
                <li>• جرب البحث مرة أخرى لاحقاً</li>
                <li>• قم بترقية حسابك للمزيد من النتائج</li>
              </ul>
            </div>

            <div className="space-y-3">
              <Button
                onClick={() => navigate('/search')}
                className="w-full"
              >
                بحث مرة أخرى
              </Button>
              <Button
                onClick={() => navigate('/payment')}
                variant="outline"
                className="w-full"
              >
                ترقية الحساب
              </Button>
            </div>
          </div>
        )}
      </div>

      <BottomNavigation />
    </div>
  );
}
